import { Mount } from '../utils/bootstrapComponents';

require('../vendor/admin/jquery.caret');
require('../vendor/admin/jquery.slugger');
require('../vendor/admin/jquery.autosize');
require('../vendor/admin/jquery.autoGrowInput');
import * as users from '../icmib/users';
import { initTips } from '../icmib/admin/tips';
import * as admin from '../icmib/admin';
import * as dashboard from '../icmib/admin/dashboard.js';
import { dollar } from '../components/results/ResultsTable/formatters';

ICMIB.users = users;
ICMIB.admin = admin;
ICMIB.dashboard = dashboard;
ICMIB.format = { dollar };

ICMIB.admin.init();
initTips();

// expose individual react components
// Some of these components might want to be their own entries

let resolver = null;

function assignResolver() {
  resolver = require.context('../splits/admin', true, /\.js$/);
}
assignResolver();

function bootstrapComponents() {
  assignResolver();
  Mount.init(resolver);
}
$(bootstrapComponents);

if (module.hot) {
  module.hot.accept(resolver.id, bootstrapComponents);
}
$('body').removeClass('no-js');
